import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) {
      toast.error('Te rugăm să completezi toate câmpurile');
      return;
    }

    setLoading(true);
    try {
      const result = await login(form.email, form.password);
      toast.success('Bine ai revenit!');
      // Redirect admin users to admin dashboard
      if (result.user.is_admin) {
        navigate('/admin');
      } else {
        navigate('/');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Date de autentificare invalide');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-12">
          <h1 className="font-heading font-bold text-4xl tracking-tight uppercase text-white" data-testid="login-title">
            CONECTARE
          </h1>
          <p className="font-body text-white/50 mt-2">Bine ai revenit la DEPRO KICKS</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <Label className="font-body text-white/70 mb-2 block">Email</Label>
            <Input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="bg-[#121212] border-white/10 text-white rounded-none h-12"
              placeholder="emailul@tau.com"
              data-testid="email-input"
            />
          </div>
          <div>
            <Label className="font-body text-white/70 mb-2 block">Parolă</Label>
            <Input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="bg-[#121212] border-white/10 text-white rounded-none h-12"
              placeholder="••••••••"
              data-testid="password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#c00000] text-white hover:bg-[#a00000] rounded-none py-6 font-heading font-bold tracking-wider"
            data-testid="login-submit-btn"
          >
            {loading ? 'SE CONECTEAZĂ...' : 'CONECTARE'}
          </Button>
        </form>

        <p className="text-center mt-8 font-body text-white/50">
          Nu ai cont?{' '}
          <Link to="/register" className="text-[#c00000] hover:underline" data-testid="register-link">
            Înregistrează-te
          </Link>
        </p>
      </motion.div>
    </div>
  );
};

export default LoginPage;
